import { render, staticRenderFns } from "./DefaultView.vue?vue&type=template&id=25062bf2&scoped=true&"
import script from "./DefaultView.vue?vue&type=script&setup=true&lang=js&"
export * from "./DefaultView.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DefaultView.vue?vue&type=style&index=0&id=25062bf2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25062bf2",
  null
  
)

export default component.exports